import { consume } from "@ndn/endpoint";
import { Interest } from "@ndn/packet";
import { defaultSegmentConvention, defaultVersionConvention } from "./convention_browser.js";
/**
 * Discover version with CanBePrefix.
 * @param name - Name without version component.
 * @returns Promise that resolves to versioned name annotated with identified conventions.
 */
export async function discoverVersion(name, { cOpts, versionConvention = defaultVersionConvention, segmentNumConvention = defaultSegmentConvention, conventions: conventionsInput = [], expectedSuffixLen = 2, } = {}) {
    const interest = new Interest(name, Interest.CanBePrefix, Interest.MustBeFresh);
    const data = await consume(interest, {
        describe: `discoverVersion(${name})`,
        ...cOpts,
    });
    const conventions = conventionsInput.length > 0 ? conventionsInput : [[versionConvention, segmentNumConvention]];
    const vComp = data.name.get(-2);
    const sComp = data.name.get(-1);
    let index;
    if (!checkSuffixLength(expectedSuffixLen, data.name.length - name.length) ||
        (index = conventions.findIndex(([v, s]) => v.match(vComp) && s.match(sComp))) < 0) {
        throw new Error(`cannot extract version from ${data.name}`);
    }
    return Object.defineProperties(data.name.getPrefix(-1), {
        versionConvention: { value: conventions[index][0] },
        segmentNumConvention: { value: conventions[index][1] },
    });
}
(function (discoverVersion) {
    discoverVersion.ANY_SUFFIX_LEN = Symbol("@ndn/segmented-object#discoverVersion.ANY_SUFFIX_LEN");
})(discoverVersion || (discoverVersion = {}));
function checkSuffixLength(expected, actual) {
    return (expected === discoverVersion.ANY_SUFFIX_LEN) ||
        (Array.isArray(expected) && expected.includes(actual)) ||
        expected === actual;
}
